// extracted by mini-css-extract-plugin
export default {"clockLoader":"ZKuIn","hand":"xs8Cf","hour":"RAjwS","tic":"iYvmC","minute":"HTqNC"};